import { render, staticRenderFns } from "./Lektionen.vue?vue&type=template&id=81810b68"
import script from "./Lektionen.vue?vue&type=script&lang=js"
export * from "./Lektionen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports